<template>
  <v-select
    v-model="select"
    label="Filtrar por lista ou grupo"
    :items="selectItems"
    item-text="text"
    item-value="value"
    prepend-icon="mdi-bank-transfer"
    dense
    filled
    hide-details
    solo-inverted
    @change="setSelectTypeBankStatement"
  ></v-select>
</template>
<script>
export default {
  name: "components-common-filters-select-type-bankStatement",
  data: () => ({
    // V-select
    selectItems: [],
    select: "",
  }),
  mounted() {
    // console.log(this.$route.name);
    this.routeChange(this.$route);
  },
  watch: {
    $route(val) {
      this.routeChange(val);
    },
  },
  methods: {
    setSelectTypeBankStatement(status) {
      this.$store.commit("setSelectTypeBankStatement", status);
    },
    routeChange(val) {
      // console.log(val.name);
      if (
        val.name == "AdministratorAccountabilityOnlineDeposits" ||
        val.name == "CollaboratorAccountabilityOnlineDeposits"
      ) {
        (this.select = "1"),
          (this.selectItems = [
            {
              text: this.$t("depositRequested"),
              value: "1",
            },
            {
              text: this.$t("depositConsolidated"),
              value: "3",
            },
            {
              text: this.$t("depositCancelled"),
              value: "4",
            },
            {
              text: this.$t("all"),
              value: "",
            },
          ]);
        this.setSelectTypeBankStatement(this.select);
      }
      if (
        val.name == "ListWithdraws" ||
        val.name == "CollaboratorListWithdraws"
      ) {
        (this.select = ""),
          (this.selectItems = [
            {
              text: this.$t("withdrawalRequisted"),
              value: "1",
            },
            {
              text: this.$t("witdhdrawalAuthorized"),
              value: "2",
            },
            {
              text: this.$t("withdrawalConsolidated"),
              value: "3",
            },
            {
              text: this.$t("withdrawalCancelled"),
              value: "4",
            },
            {
              text: this.$t("all"),
              value: "",
            },
          ]);
        this.setSelectTypeBankStatement(this.select);
      }
      if (
        val.name == "AdministratorListBonusOnline" ||
        val.name == "CollaboratorListBonusOnline"
      ) {
        (this.select = ""),
          (this.selectItems = [
            {
              text: this.$t("bonusCancelled"),

              value: "4",
            },
            {
              text: this.$t("bonusRequested"),
              value: "1",
            },
            {
              text: this.$t("bonusConsolidated"),
              value: "3",
            },

            {
              text: this.$t("all"),
              value: "",
            },
          ]);
        this.setSelectTypeBankStatement(this.select);
      }
    },
  },
};
</script>
